/* eslint-disable import/prefer-default-export */
export const GET_HOSPITALS = 'COMMON/get_hospitals';
export const GET_CITIZENSHIP = 'GET_CITIZENSHIP';

export const GET_ASSESSMENT_FEES = 'LCR/get_assessment_fees';
export const UPDATE_ASSESSMENT_FEES = 'LCR/update_assessment_fees';

export const LCR_E2E_EOR_URL =
  '/api/v1/administrators/transaction_histories/lcr/{id}/view_eor';

export const DEPENDENCIES = {
  health_certificate_amount: {
    label: 'Health Certificate',
  },
  occupational_permit_amount: {
    label: 'Occupational Permit',
  },
  card_type: {
    label: 'CARD TYPE',
  },
  stool_amount: {
    label: 'Stool',
  },
  sputum_amount: {
    label: 'Sputum',
  },
  drug_test_amount: {
    label: 'Drug Test',
  },
  rpr_syphilis_amount: {
    label: 'RPR Syphilis',
  },
  gram_stain: {
    label: 'Gram Stain',
  },
};

export const EXTENSION_NAMES = [
  { label: 'N/A', value: '' },
  { label: 'JR', value: 'JR' },
  { label: 'SR', value: 'SR' },
  { label: 'II', value: 'II' },
  { label: 'III', value: 'III' },
  { label: 'IV', value: 'IV' },
  { label: 'V', value: 'V' },
  { label: 'VI', value: 'VI' },
  { label: 'VII', value: 'VII' },
  { label: 'VIII', value: 'VIII' },
  { label: 'IX', value: 'IX' },
  { label: 'X', value: 'X' },
  { label: 'XI', value: 'XI' },
  { label: 'XII', value: 'XII' },
  { label: 'XIII', value: 'XIII' },
  { label: 'XIV', value: 'XIV' },
  { label: 'XV', value: 'XV' },
  { label: 'XVI', value: 'XVI' },
  { label: 'XVII', value: 'XVII' },
  { label: 'XVIII', value: 'XVIII' },
  { label: 'XIX', value: 'XIX' },
  { label: 'XX', value: 'XX' },
];

export const GENDER = [
  {
    label: 'FEMALE',
    value: 'FEMALE',
  },
  {
    label: 'MALE',
    value: 'MALE',
  },
];

export const YES_OR_NO = [
  { label: 'YES', value: 1 },
  { label: 'NO', value: 0 },
];

export const WHAT_TO_PRINT = [
  { label: 'BACK', value: 'BACK' },
  { label: 'FRONT', value: 'FRONT' },
  { label: 'FRONT AND BACK', value: 'FRONT AND BACK' },
];

export const PURPOSES = [
  { label: 'Claim Benefits/ Loan', value: 'Claim Benefits/ Loan' },
  { label: 'Employment Abroad', value: 'Employment Abroad' },
  { label: 'Employment Local', value: 'Employment Local' },
  { label: 'Passport / Travel', value: 'Passport / Travel' },
  { label: 'School Requirements', value: 'School Requirements' },
  { label: 'Others', value: 'Others' },
];

export const VALID_IDS = [
  {
    label: 'Authorization Letter',
    value: 'Authorization Letter',
  },
  {
    label: 'BARANGAY ID',
    value: 'BARANGAY ID',
  },
  {
    label: "DRIVER's LICENSE",
    value: "DRIVER's LICENSE",
  },
  {
    label: 'PASSPORT',
    value: 'PASSPORT',
  },
  {
    label: 'PHILHEALTH',
    value: 'PHILHEALTH',
  },
  {
    label: 'PHILSYS NATIONAL ID',
    value: 'PHILSYS NATIONAL ID',
  },
  {
    label: 'POSTAL ID',
    value: 'POSTAL ID',
  },
  {
    label: 'SSS',
    value: 'SSS',
  },
  {
    label: "SENIOR CITIZEN's ID",
    value: "SENIOR CITIZEN's ID",
  },
  {
    label: 'UMID',
    value: 'UMID',
  },
  {
    label: "VOTER's ID",
    value: "VOTER's ID",
  },
];

export const RELATIONSHIPS = [
  {
    label: 'AUTHORIZED GUARDIAN/INSTITUTION-IN-CHARGE',
    value: 'AUTHORIZED GUARDIAN/INSTITUTION-IN-CHARGE',
  },
  { label: 'BROTHER', value: 'BROTHER' },
  { label: 'COUSIN', value: 'COUSIN' },
  { label: 'DAUGHTER', value: 'DAUGHTER' },
  { label: 'FATHER', value: 'FATHER' },
  { label: 'GRANDCHILD', value: 'GRANDCHILD' },
  { label: 'MOTHER', value: 'MOTHER' },
  { label: 'NEPHEW/NIECE', value: 'NEPHEW/NIECE' },
  { label: 'OTHERS', value: 'OTHERS' },
  { label: 'GRANDPARENT', value: 'GRANDPARENT' },
  { label: 'SELF', value: 'SELF' },
  { label: 'SON', value: 'SON' },
  { label: 'SPOUSE', value: 'SPOUSE' },
  { label: 'SISTER', value: 'SISTER' },
  { label: 'UNCLE/AUNT', value: 'UNCLE/AUNT' },
];
